import { Button } from "@mui/material";
import { useModalContext } from "components/modal/inside/ModalProvider";
import { UploadKioskBannerModal } from "components/modal/inside/upload/UploadKioskBannerModal";
import { FC } from "react";

export type SetupBannerButtonProps = {
  icao: string;
  onSuccess?: () => void;
};

export const SetupBannerButton: FC<SetupBannerButtonProps> = (props) => {
  const { show } = useModalContext();
  return (
    <Button
      onClick={() =>
        show(
          <UploadKioskBannerModal
            icao={props.icao}
            onUploadSuccess={props.onSuccess}
          />
        )
      }
    >
      Setup banner
    </Button>
  );
};
